// extracted by mini-css-extract-plugin
module.exports = {"toggle":"App_toggle__1zy5H","dayNight":"App_dayNight__1a5ji"};